// Shared scale bracket configuration
export const scaleBrackets = [
  {
    label: 'Up to $10k sales per month',
    value: 10000,
    monthlyPrice: 9900,
    yearlyPrice: 8300,
    yearlyPriceFull: 99000,
  },
  {
    label: 'Up to $30k sales per month',
    value: 30000,
    monthlyPrice: 23900,
    yearlyPrice: 19900,
    yearlyPriceFull: 239000,
  },
  {
    label: 'Up to $50k sales per month',
    value: 50000,
    monthlyPrice: 39900,
    yearlyPrice: 33300,
    yearlyPriceFull: 399000,
  },
  {
    label: 'Up to $75k sales per month',
    value: 75000,
    monthlyPrice: 59900,
    yearlyPrice: 49900,
    yearlyPriceFull: 599000,
  },
  {
    label: 'Up to $100k sales per month',
    value: 100000,
    monthlyPrice: 74900,
    yearlyPrice: 62500,
    yearlyPriceFull: 749000,
  },
  {
    label: 'Up to $100k+ sales per month',
    value: 150000,
    monthlyPrice: 74900,
    yearlyPrice: 62500,
    yearlyPriceFull: 749000,
  },
];

export default scaleBrackets;
